export default __webpack_public_path__ + "static/media/unplugged_icon.ee747f16.svg";